/*
 * Variant Image Switcher for Shopify - v6
 * Automatically updates the main product image when a variant is selected
 * AND properly updates the hidden "id" input fields for Add to Cart
 * PLUS: Updates month supply text based on product type (Focus vs Relax)
 */

// Define month supply text for each product and variant
const MONTH_SUPPLY_MAP = {
  'focus': {
    '1 bottle': '1 month supply',
    '2 bottles': '2 months supply',
    '3 bottles': '3 months supply'
  },
  'relax': {
    '1 bottle': '2 months supply',
    '2 bottles': '4 months supply',
    '3 bottles': '6 months supply'
  }
};

document.addEventListener('DOMContentLoaded', function() {
  // Add data-variant-image attributes to variant cards if they don't exist
  addVariantImageAttributes();
  
  // Initialize month supply text for all cards
  initializeMonthSupplyText();
  
  // Listen for variant selection changes
  setupVariantListeners();
});

function getProductType() {
  // Get product type from page title or URL
  const pageTitle = document.querySelector('h1')?.textContent || '';
  const url = window.location.pathname;
  
  if (pageTitle.toLowerCase().includes('focus') || url.includes('focus')) {
    return 'focus';
  } else if (pageTitle.toLowerCase().includes('relax') || url.includes('relax')) {
    return 'relax';
  }
  
  return 'focus'; // default to focus
}

function getVariantBottleCount(variantName) {
  // Extract bottle count from variant name
  // e.g., "1 Bottle (60 Capsules)" -> "1 bottle"
  const match = variantName.match(/(\d+)\s+bottle/i);
  if (match) {
    return match[1].toLowerCase() + ' bottle' + (match[1] !== '1' ? 's' : '');
  }
  return null;
}

function addVariantImageAttributes() {
  // Find all variant cards (they're usually labels or divs with variant data)
  const variantCards = document.querySelectorAll('[data-variant-id]');
  
  variantCards.forEach(card => {
    // Check if it already has the image attribute
    if (!card.getAttribute('data-variant-image')) {
      // Try to find the image URL from the card's content or structure
      const img = card.querySelector('img');
      if (img && img.src) {
        card.setAttribute('data-variant-image', img.src);
      }
    }
  });
}

function initializeMonthSupplyText() {
  const productType = getProductType();
  const variantCards = document.querySelectorAll('[data-variant-id]');
  
  variantCards.forEach(card => {
    // Find the variant name in the card
    const variantNameElement = card.querySelector('[class*="__name"]');
    if (variantNameElement) {
      const variantName = variantNameElement.textContent.trim();
      const bottleCount = getVariantBottleCount(variantName);
      
      if (bottleCount && MONTH_SUPPLY_MAP[productType][bottleCount]) {
        // Find and update the month supply element
        const supplyElement = card.querySelector('[class*="__supply"]');
        if (supplyElement) {
          supplyElement.textContent = MONTH_SUPPLY_MAP[productType][bottleCount];
        }
      }
    }
  });
}

function setupVariantListeners() {
  const variantCards = document.querySelectorAll('[data-variant-id]');
  
  variantCards.forEach(card => {
    card.addEventListener('click', function(e) {
      const variantId = this.getAttribute('data-variant-id');
      const imageUrl = this.getAttribute('data-variant-image');
      
      // Update the image
      if (imageUrl) {
        updateProductImage(imageUrl);
      }
      
      // Update month supply text
      updateMonthSupplyText(this);
      
      // CRITICAL: Update ALL hidden input fields with name="id" to the new variant ID
      const hiddenIdInputs = document.querySelectorAll('input[type="hidden"][name="id"]');
      hiddenIdInputs.forEach(input => {
        input.value = variantId;
      });
      
      // Also update the radio buttons
      const variantInput = document.querySelector(`input[type="radio"][value="${variantId}"]`);
      if (variantInput) {
        variantInput.checked = true;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Update sticky add to cart bar
      updateStickyBar(variantId, this);
      
      console.log('✓ Updated variant ID to:', variantId);
      console.log('✓ Updated hidden inputs:', hiddenIdInputs.length);
    });
  });
}

function updateProductImage(imageUrl) {
  // Find the main product image - try multiple selectors
  let mainImage = document.querySelector('.product-media__image');
  if (!mainImage) {
    mainImage = document.querySelector('[class*="product-image"]');
  }
  if (!mainImage) {
    mainImage = document.querySelector('img[alt*="product"]');
  }
  
  if (mainImage) {
    mainImage.src = imageUrl;
    mainImage.srcset = imageUrl;
    console.log('✓ Updated main image to:', imageUrl);
  }
}

function updateMonthSupplyText(variantCard) {
  const productType = getProductType();
  
  // Find the variant name in the card
  const variantNameElement = variantCard.querySelector('[class*="__name"]');
  if (!variantNameElement) return;
  
  const variantName = variantNameElement.textContent.trim();
  const bottleCount = getVariantBottleCount(variantName);
  
  if (!bottleCount || !MONTH_SUPPLY_MAP[productType][bottleCount]) return;
  
  // Find and update the month supply element
  const supplyElement = variantCard.querySelector('[class*="__supply"]');
  if (supplyElement) {
    supplyElement.textContent = MONTH_SUPPLY_MAP[productType][bottleCount];
    console.log('✓ Updated month supply to:', MONTH_SUPPLY_MAP[productType][bottleCount]);
  }
}

function updateStickyBar(variantId, variantCard) {
  // Update the sticky bar's data-current-variant-id attribute
  // This triggers Shopify's native update mechanism
  const stickyBar = document.querySelector('.sticky-add-to-cart');
  if (stickyBar) {
    stickyBar.setAttribute('data-current-variant-id', variantId);
    console.log(`✓ Updated sticky bar variant ID to: ${variantId}`);
  }
  
  // Update the variant name in the sticky bar (the second line)
  const variantNameElement = variantCard.querySelector('[class*="__name"]');
  if (variantNameElement) {
    const variantName = variantNameElement.textContent.trim();
    const stickyBarVariant = document.querySelector('.sticky-add-to-cart__variant');
    if (stickyBarVariant) {
      stickyBarVariant.textContent = variantName;
      console.log(`✓ Updated sticky bar variant to: ${variantName}`);
    }
  }
  
  // Update the sticky bar image
  const variantImageUrl = variantCard.getAttribute('data-variant-image');
  if (variantImageUrl) {
    const stickyBarImage = document.querySelector('.sticky-add-to-cart__image img');
    if (stickyBarImage) {
      stickyBarImage.src = variantImageUrl;
      console.log(`✓ Updated sticky bar image`);
    }
  }
  
  // Update the sticky bar price manually since Shopify's native update isn't working
  updateStickyBarPrice(variantCard);
}

function updateStickyBarPrice(variantCard) {
  // Get the price from the variant card
  const priceElement = variantCard.querySelector('[class*="__actual-price"]');
  const comparePriceElement = variantCard.querySelector('[class*="__compare-price"]');
  
  if (!priceElement) return;
  
  const salePrice = priceElement.textContent.trim();
  const comparePrice = comparePriceElement ? comparePriceElement.textContent.trim() : null;
  
  // Update sticky bar price
  const stickyPriceElement = document.querySelector('.sticky-add-to-cart__price');
  if (stickyPriceElement) {
    // Update the sale price
    const priceSpan = stickyPriceElement.querySelector('.price');
    if (priceSpan) {
      priceSpan.textContent = salePrice;
    }
    
    // Update the compare price (if exists)
    const comparePriceSpan = stickyPriceElement.querySelector('.compare-at-price');
    if (comparePriceSpan && comparePrice) {
      comparePriceSpan.textContent = comparePrice;
    }
    
    console.log(`✓ Updated sticky bar price to: ${salePrice}`);
  }
  
  // Also update the header price (below the 5 stars rating)
  // Find the product-price component and update its price elements
  const productPrice = document.querySelector('product-price');
  if (productPrice) {
    const headerPriceSpan = productPrice.querySelector('.price');
    const headerComparePriceSpan = productPrice.querySelector('.compare-at-price');
    
    if (headerPriceSpan) {
      headerPriceSpan.textContent = salePrice;
    }
    
    if (headerComparePriceSpan && comparePrice) {
      headerComparePriceSpan.textContent = comparePrice;
    }
    
    console.log(`✓ Updated header price to: ${salePrice}`);
  }
}

// Also listen for Shopify's built-in variant change events
if (window.Shopify) {
  document.addEventListener('shopify:variant:change', function(e) {
    if (e.detail && e.detail.variant && e.detail.variant.featured_image) {
      updateProductImage(e.detail.variant.featured_image.src);
    }
  });
}

// Initialize on page load and after any dynamic updates
window.addEventListener('load', function() {
  addVariantImageAttributes();
  initializeMonthSupplyText();
  setupVariantListeners();
});